import { render, staticRenderFns } from "./SpeakersLounge.vue?vue&type=template&id=f28a43b2&scoped=true&"
import script from "./SpeakersLounge.vue?vue&type=script&lang=js&"
export * from "./SpeakersLounge.vue?vue&type=script&lang=js&"
import style0 from "./SpeakersLounge.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SpeakersLounge.vue?vue&type=style&index=1&id=f28a43b2&scoped=true&lang=css&"
import style2 from "./SpeakersLounge.vue?vue&type=style&index=2&id=f28a43b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28a43b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
